module.exports = __webpack_public_path__ + "img/lebenslagen.c00eb769.svg";